var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2451_82663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.68008 0.125C0.777322 0.125 0.0429688 0.859403 0.0429688 1.76211C0.0429688 2.66482 0.777018 3.39917 1.68008 3.39917C2.58314 3.39917 3.31719 2.66482 3.31719 1.76211C3.31719 0.859403 2.58279 0.125 1.68008 0.125Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97695 0.125C6.07425 0.125 5.33984 0.859403 5.33984 1.76211C5.33984 2.66482 6.07425 3.39917 6.97695 3.39917C7.87971 3.39917 8.61422 2.66482 8.61422 1.76211C8.61422 0.859403 7.88002 0.125 6.97695 0.125Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3637 3.39922C13.2662 3.39922 14.0008 2.66487 14.0008 1.76216C14.0008 0.859454 13.2668 0.125 12.3637 0.125C11.4605 0.125 10.7266 0.859403 10.7266 1.76211C10.7266 2.66482 11.4611 3.39922 12.3637 3.39922Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.63742 8.64542C2.54012 8.64542 3.27468 7.91122 3.27468 7.00836C3.27468 6.10545 2.54012 5.37109 1.63742 5.37109C0.734708 5.37109 0 6.1055 0 7.00836C0 7.91122 0.734708 8.64542 1.63742 8.64542Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93399 8.64542C7.83654 8.64542 8.5711 7.91122 8.5711 7.00836C8.5711 6.10545 7.83715 5.37109 6.93399 5.37109C6.03097 5.37109 5.29688 6.10545 5.29688 7.00836C5.29687 7.91122 6.03128 8.64542 6.93399 8.64542Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3213 8.64542C13.2242 8.64542 13.9584 7.91122 13.9584 7.00836C13.9584 6.10545 13.2242 5.37109 12.3213 5.37109C11.4184 5.37109 10.6836 6.10545 10.6836 7.00836C10.6836 7.91122 11.4181 8.64542 12.3213 8.64542Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.67648 10.6016C0.77377 10.6016 0.0390625 11.3358 0.0390625 12.2387C0.0390625 13.1412 0.77377 13.8757 1.67648 13.8757C2.57919 13.8757 3.31354 13.1416 3.31354 12.2387C3.31354 11.3358 2.57919 10.6016 1.67648 10.6016Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97335 10.6016C6.07059 10.6016 5.33594 11.3358 5.33594 12.2387C5.33594 13.1412 6.07034 13.8757 6.97335 13.8757C7.87591 13.8757 8.61041 13.1416 8.61041 12.2387C8.61041 11.3358 7.87591 10.6016 6.97335 10.6016Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3559 10.6016C11.4533 10.6016 10.7188 11.3358 10.7188 12.2387C10.7188 13.1412 11.4533 13.8757 12.3559 13.8757C13.2588 13.8757 13.993 13.1416 13.993 12.2387C13.993 11.3358 13.2584 10.6016 12.3559 10.6016Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2451_82663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/AppIcon.093c8e600e87f9ee1668bd9b6c047554.svg";
export { ForwardRef as ReactComponent };